export default __webpack_public_path__ + "static/media/guitar_smash.c8ac02c8.mp4";